export default __webpack_public_path__ + "static/media/icon-algostudy-n@2x.d8d11d12.webp";